export default __webpack_public_path__ + "static/media/jun_logo.57d8a7c3.png";